import axios from "axios";
import * as authservice from "./authServices";

// Test
// const baseURL = "https://staging-adminapi.billerq.app/api/";
// const baseURL = "https://admin.billerq.com/public/api/";

// const baseURL = "https://admin.billerq.com/public/api/";

// Live
const baseURL = "https://adminapi.billerq.app/api/";

function getToken() { 
  if (authservice.isLoggedIn()) {
    const userToken = authservice.getUser().userToken;
    return {
      Authorization: "Bearer " + userToken,
    };
  } else {
    return null;
  }
}

function getMasterToken() {
  if (authservice.isLoggedIn()) {
    const masterToken = authservice.getUser()?.userToken;

    return {
      Authorization: `Bearer ${masterToken}`,  // FIXED
      Accept: "application/json"
    };
  }
  return {};
}

export async function getMasterDataToken(url) {
  try {
    const headers = getMasterToken();
    const response = await axios.get(`${baseURL}${url}`, { headers });

    if (response.status === 200) {
      return response;
    }

    return undefined;

  } catch (error) {
    console.error(error);
    return undefined;
  }
}


export async function PostMasterDataToken(url, data) {
  try {
    const headers = {
      ...getMasterToken(),
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    };

    const response = await axios.post(`${baseURL}${url}`, data, { headers });

    return response;
    
  } catch (error) {
    console.log("POST ERROR:", error?.response);
    throw error;
  }
}

export async function postMasterToken(url, data) {
  try {
    const reqHeader = getMasterToken();
    const response = await axios.post(`${baseURL}${url}`, data, {
      headers: reqHeader,
    });
    //console.log("ress", response);
    return response ? response : undefined;
  } catch (error) {
    console.error(error);
  }
}

export async function getDat2(clientUrl,url) {
  console.log(clientUrl)
  try {
    const response = await axios.get(`${clientUrl}${url}`, {
      headers: {
        Authorization: "amji123",
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      return undefined;
    }
  } catch (error) {
    console.error(error);
    return undefined;
  }
}
export async function postDat2(clientUrl,url,data) {
  try {
    const response = await axios.post(`${clientUrl}${url}`,data, {
      headers: {
        Authorization: "amji123",
      }
    });

    if (response.status === 200) {
      return response.data;
    } else {
      return undefined;
    }
  } catch (error) {
    console.error(error);
    return undefined;
  }
}
export async function getData(url) {
  try {
    // const response = await axios.get(`${baseURL}${url}`, {
    //   headers: getToken(),
    // });
    const response = await axios.get(`${baseURL}${url}`);
    //console.log('response>>> ', response.status);
    if (response.status === 200) {
      return response.data;
    } else {
      return undefined;
    }
  } catch (error) {
    console.error(error);
    return undefined;
  }
}

export async function getDataWithToken(url) {
  try {
    const response = await axios.get(`${baseURL}${url}`, {
      headers: getToken(),
    });
    // const response = await axios.get(`${baseURL}${url}`);
    //console.log('response>>> ', response.status);
    if (response.status === 200) {
      return response.data;
    } else {
      return undefined;
    }
  } catch (error) {
    console.error(error);
    return undefined;
  }
}
export async function getDataWithTokenDemo(url) {
  try {
    const response = await axios.get(`${baseURL}${url}`, {
      headers: getToken(),
    });
    // const response = await axios.get(`${baseURL}${url}`);
    //console.log('response>>> ', response.status);
    if (response.status === 200) {
      return response.data;
    } else {
      return undefined;
    }
  } catch (error) {
    console.error(error);
    return undefined;
  }
}
export async function putData(url, data) {
  try {
    // const response = await axios.put(`${baseURL}${url}`, data, {
    //   headers: getToken(),
    // });
    //console.log(`${baseURL}${url}`);
    const response = await axios.put(`${baseURL}${url}`, data);
    //console.log("ress>>> ", response);
    if (response.status === 200) {
      return response;
    } else {
      return undefined;
    }
  } catch (error) {
    console.error(error);
  }
}

export async function deleteData(url) {
  try {
    const response = await axios.delete(`${baseURL}${url}`, {
      headers: getToken(),
    });
    // console.log("ress", response);
    if (response.status === 204) {
      return response;
    } else {
      return undefined;
    }
  } catch (error) {
    console.error(error);
  }
}

export async function postDataWithToken(url, data) {
  try {
    const reqHeader = getToken();
    const response = await axios.post(`${baseURL}${url}`, data, {
      headers: reqHeader,
    });
    // console.log("ress", response);
    return response ? response : undefined;
  } catch (error) {
    console.error(error);
  }
}

export async function postDataWithoutToken(url, data) {
  try {
    //const reqHeader = getToken();
    const response = await axios.post(`${baseURL}${url}`, data, {
      // headers: reqHeader,
    });
    //console.log("ress", response);
    return response ? response : undefined;
  } catch (error) {
    console.error(error);
    return error
  }
}
